import React, { useState, useEffect, useRef } from "react";
import FormField from "../../Common/FormFeild";
import DynamicArray from "../../ContentCreator/DynamicArray";
import Button from "../../Common/Button";
import LanguageMultiSelect from "../../Common/LanguageSelect";
import LocationMultiSelect from "../../Common/MultiLocationSelector";
import {
  Department,
  getDepartmentAPI,
  getDesignationAPI,
  getLanguageAPI,
  getLocationAPI,
  getSpecializationAPI,
  getTitleAPI,
  Specialization,
} from "../../Api/LookUp";
import SearchableDropdown from "../../Common/SearchableDropdown";
import { Toast } from "../../Common/Toast";
import { createNewDoctor } from "../../Api/MarketingApi";
import axios from "axios";
import Doctor from "./../../../images/doctorAvtar.png"
import { useNavigate } from "react-router-dom";
/* ================= TYPES ================= */

interface RoleDescription {
  role: string;
  description: string;
}

interface LookupOption {
  id: number;
  label: string;
}

interface Language {
  LangId: number;
  Name: string;
}

interface SecondaryLocation {
  locationId: number;
}

interface ValidationErrors {
  name?: string;
  namePrefixCode?: string;
  locationName?: string;
  designation?: string;
  experience?: string;
  fee?: string;
  languages?: string;
  summary?: string;
  qualification?: string;
  registrationNo?: string;
  doctorImage?: string;
  department?: string;
  specialization?: string;
  gender?: string;
  email?: string;
  phone?: string;
  EmpCode?:string;
}

interface DynamicFieldErrors {
  [key: string]: string;
}

interface DoctorFormData {
  name: string;
  namePrefixCode: string;
  locationId: number | null;
  locationName: string;
  designation: string;
  designationId: number | null;
  experience: string;
  fee: string;
  languages: string;
  qualification: string;
  summary: string;
  specializationId: number | null;
  registrationNo: string;
  gender: string;
  emailID: string;
  phoneNo: string;
  status: string;
  feedback: string;
  remark: string;
  event: string;
  areaOfInterest: RoleDescription[];
  previousExperiance: RoleDescription[];
  awards: string[];
  publications: string[];
  secondaryLocations: SecondaryLocation[];
  EmpCode:string
}

/* ================= UTILITY FUNCTIONS ================= */

const hasEmptyFields = <T extends Record<string, any>>(
  items: T[],
  fields: (keyof T)[]
): boolean => {
  if (items.length === 0) return false;
  return items.some((item) =>
    fields.some((field) => !String(item[field]).trim())
  );
};

const extractNumericValue = (value: string): number => {
  return parseInt(value.replace(/\D/g, "")) || 0;
};

const capitalizeWords = (str: string): string => {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/* ================= REUSABLE COMPONENTS ================= */

const ValidationErrorMessage: React.FC<{ message: string }> = ({ message }) => (
  <p className="text-xs text-red-600 mt-1 flex items-center gap-1">
    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clipRule="evenodd"
      />
    </svg>
    {message}
  </p>
);

const ErrorBanner: React.FC<{ message: string }> = ({ message }) => (
  <div className="mb-2 w-fit max-w-full">
    <div className="flex items-center gap-2 px-3 py-1 text-xs text-red-700 bg-red-50 border-l-4 border-red-500 rounded-md shadow-sm">
      <svg
        className="w-4 h-4 flex-shrink-0 text-red-600"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
          clipRule="evenodd"
        />
      </svg>
      <span>{message}</span>
    </div>
  </div>
);

/* ================= MAIN COMPONENT ================= */

const CreateDoctorProfile: React.FC = () => {
  const userId = sessionStorage.getItem("userId");
  const userIp = sessionStorage.getItem("userIp") || "0.0.0.0";
  const MAXFILESIZEBYTES = 5 * 1024 * 1024;
const navigate=useNavigate();
  // Refs for scroll to error
  const nameRef = useRef<HTMLInputElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const locationRef = useRef<HTMLDivElement>(null);
  const secondaryLocationsRef = useRef<HTMLDivElement>(null);
  const designationRef = useRef<HTMLDivElement>(null);
  const experienceRef = useRef<HTMLInputElement>(null);
  const feeRef = useRef<HTMLInputElement>(null);
  const languagesRef = useRef<HTMLDivElement>(null);
  const summaryRef = useRef<HTMLTextAreaElement>(null);
  const registrationNoRef = useRef<HTMLInputElement>(null);
  const employeCodeRef = useRef<HTMLInputElement>(null);
  const doctorImageRef = useRef<HTMLDivElement>(null);
  const departmentRef = useRef<HTMLDivElement>(null);
  const specializationRef = useRef<HTMLDivElement>(null);
  const qualificationRef = useRef<HTMLTextAreaElement>(null);
  const genderRef = useRef<HTMLDivElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);

  const [formData, setFormData] = useState<DoctorFormData>({
    name: "",
    namePrefixCode: "",
    locationId: null,
    locationName: "",
    designation: "",
    designationId: null,
    experience: "",
    fee: "",
    languages: "",
    qualification: "",
    summary: "",
    specializationId: null,
    registrationNo: "",
    gender: "",
    emailID: "",
    phoneNo: "",
    status: "",
    feedback: "",
    remark: "Create New Doctor Profile",
    event: "Add New Doctor Profile",
    areaOfInterest: [],
    previousExperiance: [],
    awards: [],
    publications: [],
    secondaryLocations: [],
    EmpCode:""
  });

  const [doctorImageFile, setDoctorImageFile] = useState<File | null>(null);
  const [doctorImagePreview, setDoctorImagePreview] = useState<string>("");
  const [uploadedImagePath, setUploadedImagePath] = useState<string>("");

  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState("");
  const [validationErrors, setValidationErrors] = useState<ValidationErrors>({});
  const [showValidationAlert, setShowValidationAlert] = useState(false);
  const [dynamicFieldErrors, setDynamicFieldErrors] = useState<DynamicFieldErrors>({});

  const [availableLanguages, setAvailableLanguages] = useState<Language[]>([]);
  const [locations, setLocations] = useState<LookupOption[]>([]);
  const [departments, setAvailableDepartment] = useState<Department[]>([]);
  const [specializations, setAvailableSpecialization] = useState<Specialization[]>([]);
  const [designations, setDesignations] = useState<LookupOption[]>([]);
  const [titles, setTitles] = useState<LookupOption[]>([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState<number | null>(null);

  const validationState = {
    areaOfInterest: hasEmptyFields(formData.areaOfInterest, ["role", "description"]),
    previousExperiance: hasEmptyFields(formData.previousExperiance, ["role", "description"]),
    awards: formData.awards.length > 0 && formData.awards.some((item) => !item.trim()),
    publications: formData.publications.length > 0 && formData.publications.some((item) => !item.trim()),
  };

  // Fetch Languages
  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await getLanguageAPI();
        setAvailableLanguages(response.data);
      } catch (error) {
        console.error("Error fetching languages", error);
      }
    };
    fetchLanguages();
  }, []);

  // Fetch Departments
  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartmentAPI();
        setAvailableDepartment(response.data);
      } catch (error) {
        console.error("Error fetching departments", error);
      }
    };
    fetchDepartment();
  }, []);

  // Fetch Specializations when department changes
  useEffect(() => {
    const fetchSpecializations = async () => {
      if (!selectedDepartmentId) {
        setAvailableSpecialization([]);
        return;
      }

      try {
        const response = await getSpecializationAPI(selectedDepartmentId);
        setAvailableSpecialization(response.data);
      } catch (error) {
        console.error("Error fetching specializations", error);
        setAvailableSpecialization([]);
      }
    };
    fetchSpecializations();
  }, [selectedDepartmentId]);

  // Fetch Locations, Designations, Titles
  useEffect(() => {
    getLocationAPI().then((res) =>
      setLocations(
        res.data.map((l: any) => ({
          id: l.LocationId,
          label: l.LocationName,
        }))
      )
    );

    getDesignationAPI().then((res) =>
      setDesignations(
        res.data.map((d: any) => ({
          id: d.Id,
          label: d.Designation,
        }))
      )
    );

    getTitleAPI().then((res) =>
      setTitles(
        res.data.map((t: any) => ({
          id: t.Id,
          label: t.PrefixCode,
        }))
      )
    );
  }, []);

  const update = (k: keyof DoctorFormData, v: any) => {
    setFormData((p) => ({ ...p, [k]: v }));

    if (validationErrors[k as keyof ValidationErrors]) {
      setValidationErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[k as keyof ValidationErrors];
        return newErrors;
      });
    }
  };

  // UPDATED: Registration number validation - max 30 characters
  const handleRegistrationNoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9\-\/]/g, "").slice(0, 30);
    update("registrationNo", value);
  };
  const handleEmployeeCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  let value = e.target.value;

  value = value.toUpperCase();

  
  value = value.replace(/[^A-Z0-9\-\/]/g, "");

  
  value = value.slice(0, 30);

  update("EmpCode", value);
};

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value.length <= 50) {
      const capitalized = capitalizeWords(value);
      update("name", capitalized);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    update("emailID", value);
  };

  // UPDATED: Phone validation - must start with 6-9, exactly 10 digits
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "");
    
    // Only allow input if empty or starts with 6-9
    if (value === "" || /^[6-9]/.test(value)) {
      const limitedValue = value.slice(0, 10);
      update("phoneNo", limitedValue);
    }
  };

  // UPDATED: Consultation fee validation - max 5 digits
  const handleFeeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 5);
    update("fee", value);
  };

  // UPDATED: Experience validation - max 2 digits
  const handleExperienceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 2);
    update("experience", value);
  };

  const handleDepartmentChange = (selectedOption: LookupOption) => {
    setSelectedDepartmentId(selectedOption.id);
    update("specializationId", null);

    if (validationErrors.department) {
      setValidationErrors((prev) => {
        const { department, ...rest } = prev;
        return rest;
      });
    }
  };

  const handleSpecializationChange = (selectedOption: LookupOption) => {
    update("specializationId", selectedOption.id);

    if (validationErrors.specialization) {
      setValidationErrors((prev) => {
        const { specialization, ...rest } = prev;
        return rest;
      });
    }
  };

  // UPDATED: Handle Primary Location Change - Clear secondary locations when primary changes
  const handlePrimaryLocationChange = (selectedOption: LookupOption) => {
    update("locationName", selectedOption.label);
    update("locationId", selectedOption.id);
    // Clear secondary locations when primary location changes
    update("secondaryLocations", []);
  };

  // Handle Secondary Locations Change - Store as IDs
  const handleSecondaryLocationsChange = (selectedLocationIds: string) => {
    const ids = selectedLocationIds.split(',').filter(id => id.trim());
    const secondaryLocs: SecondaryLocation[] = ids.map(id => ({ 
      locationId: parseInt(id.trim()) 
    }));
    update("secondaryLocations", secondaryLocs);
  };

  const updateRoleArray = (
    key: "areaOfInterest" | "previousExperiance",
    index: number,
    field: keyof RoleDescription,
    value: string
  ) => {
    setFormData((prev) => {
      const updated = [...prev[key]];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, [key]: updated };
    });
  };

  const addRoleRow = (key: "areaOfInterest" | "previousExperiance") => {
    if (hasEmptyFields(formData[key], ["role", "description"])) {
      setDynamicFieldErrors((prev) => ({
        ...prev,
        [key]: "Fill in all existing fields before adding a new one.",
      }));
      return;
    }
    update(key, [...formData[key], { role: "", description: "" }]);
  };

  const removeRoleRow = (key: "areaOfInterest" | "previousExperiance", index: number) => {
    setFormData((prev) => ({
      ...prev,
      [key]: prev[key].filter((_, i) => i !== index),
    }));
  };

  useEffect(() => {
    if (!validationState.areaOfInterest && dynamicFieldErrors.areaOfInterest) {
      setDynamicFieldErrors((prev) => {
        const { areaOfInterest, ...rest } = prev;
        return rest;
      });
    }
  }, [validationState.areaOfInterest, dynamicFieldErrors.areaOfInterest]);

  useEffect(() => {
    if (!validationState.previousExperiance && dynamicFieldErrors.previousExperiance) {
      setDynamicFieldErrors((prev) => {
        const { previousExperiance, ...rest } = prev;
        return rest;
      });
    }
  }, [validationState.previousExperiance, dynamicFieldErrors.previousExperiance]);

  // ================= IMAGE HANDLING =================

  const uploadDoctorImageToAPI = async (file: File): Promise<string> => {
    try {
      const formData = new FormData();
      formData.append("DoctorImage", file);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Marketing/uploadimage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success && response.data.filePath) {
        return response.data.filePath;
      } else {
        throw new Error(response.data.Message || "Image upload failed");
      }
    } catch (error: any) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };

  const handlePhotoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > MAXFILESIZEBYTES) {
      Toast.error("Photo size must be less than or equal to 5MB");
      e.target.value = "";
      return;
    }

    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    if (fileExtension !== 'webp') {
      Toast.error("Only WEBP format is accepted");
      e.target.value = "";
      return;
    }

    try {
      setLoading(true);
      setAlert("📤 Uploading image...");

      const imagePath = await uploadDoctorImageToAPI(file);
      
      setDoctorImageFile(file);
      setUploadedImagePath(imagePath);
      const previewUrl = URL.createObjectURL(file);
      setDoctorImagePreview(previewUrl);
      
      Toast.success("Photo uploaded successfully");
      setAlert("");

      if (validationErrors.doctorImage) {
        setValidationErrors((prev) => {
          const { doctorImage, ...rest } = prev;
          return rest;
        });
      }
    } catch (err: any) {
      console.error("Photo upload error:", err);
      setDoctorImageFile(null);
      setDoctorImagePreview("");
      setUploadedImagePath("");
      Toast.error(err?.response?.data?.Message || "Photo upload failed");
      setAlert("");
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const handleDeletePhoto = () => {
    if (doctorImagePreview) {
      URL.revokeObjectURL(doctorImagePreview);
    }
    setDoctorImageFile(null);
    setDoctorImagePreview("");
    setUploadedImagePath("");
  };

  useEffect(() => {
    return () => {
      if (doctorImagePreview) {
        URL.revokeObjectURL(doctorImagePreview);
      }
    };
  }, [doctorImagePreview]);

  const scrollToFirstError = (ref: React.RefObject<any>) => {
    if (ref?.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });

      setTimeout(() => {
        if (ref?.current) {
          ref.current.focus({ preventScroll: true });
        }
      }, 600);
    }
  };

  const validateAllDynamicFields = (): { isValid: boolean; errors: string[] } => {
    const errors: string[] = [];
    const newDynamicErrors: DynamicFieldErrors = {};

    if (validationState.areaOfInterest) {
      errors.push("Area of Interest has empty fields");
      newDynamicErrors.areaOfInterest = "Fill in all existing fields before proceeding";
    }

    if (validationState.previousExperiance) {
      errors.push("Previous Experience has empty fields");
      newDynamicErrors.previousExperiance = "Fill in all existing fields before proceeding";
    }

    if (validationState.awards) {
      errors.push("Awards & Achievements has empty fields");
    }

    if (validationState.publications) {
      errors.push("Research & Publications has empty fields");
    }

    setDynamicFieldErrors(newDynamicErrors);
    return {
      isValid: errors.length === 0,
      errors,
    };
  };

  const validateMandatoryFields = (): boolean => {
    const errors: ValidationErrors = {};
    let isValid = true;
    let firstErrorRef: React.RefObject<any> | null = null;

    if (!uploadedImagePath) {
      errors.doctorImage = "Doctor photo is required";
      isValid = false;
      firstErrorRef = doctorImageRef;
    }

    // UPDATED: Registration number validation with max 30 chars
    if (formData.registrationNo?.trim() && !/^[A-Z0-9\-\/]+$/.test(formData.registrationNo)) {
      errors.registrationNo = "Registration number can only contain uppercase letters, numbers, hyphens, and slashes";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = registrationNoRef;
    }
    if (formData.registrationNo?.trim() && formData.registrationNo.length > 30) {
      errors.registrationNo = "Registration number cannot exceed 30 characters";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = registrationNoRef;
    }
    // Employee Code validation
if (!formData.EmpCode?.trim()) {
  errors.EmpCode = "Employee Code is required";
  isValid = false;
  if (!firstErrorRef) firstErrorRef = employeCodeRef;
} 
else if (!/^[A-Z0-9\-\/]+$/.test(formData.EmpCode)) {
  errors.EmpCode =
    "Employee Code can contain only A-Z, 0-9, - and /";
  isValid = false;
  if (!firstErrorRef) firstErrorRef = employeCodeRef;
}
else if (formData.EmpCode.length > 30) {
  errors.EmpCode = "Employee Code cannot exceed 30 characters";
  isValid = false;
  if (!firstErrorRef) firstErrorRef = employeCodeRef;
}

    // UPDATED: Doctor name validation - min 3, max 50
    if (!formData.name?.trim()) {
      errors.name = "Doctor name is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = nameRef;
    } else if (formData.name.trim().length < 3) {
      errors.name = "Doctor name must be at least 3 characters";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = nameRef;
    } else if (formData.name.trim().length > 50) {
      errors.name = "Doctor name cannot exceed 50 characters";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = nameRef;
    }

    if (!formData.namePrefixCode?.trim()) {
      errors.namePrefixCode = "Title is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = titleRef;
    }

    if (!formData.locationName?.trim()) {
      errors.locationName = "Location is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = locationRef;
    }

    if (!formData.designation?.trim()) {
      errors.designation = "Designation is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = designationRef;
    }

    if (!selectedDepartmentId) {
      errors.department = "Department is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = departmentRef;
    }

    if (!formData.specializationId) {
      errors.specialization = "Specialization is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = specializationRef;
    }
    

    // UPDATED: Experience validation - max 2 digits
    if (!formData.experience?.trim()) {
      errors.experience = "Experience is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = experienceRef;
    } else if (!/^\d{1,2}$/.test(formData.experience)) {
      errors.experience = "Experience must be a valid number (max 2 digits)";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = experienceRef;
    }

    // UPDATED: Consultation fee validation - max 5 digits
    if (!formData.fee?.trim()) {
      errors.fee = "Consultation fee is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = feeRef;
    } else if (!/^\d{1,5}$/.test(formData.fee)) {
      errors.fee = "Consultation fee must be numeric (max 5 digits)";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = feeRef;
    }

    if (!formData.languages?.trim()) {
      errors.languages = "At least one language is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = languagesRef;
    }

    if (!formData.qualification?.trim()) {
      errors.qualification = "Qualification is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = qualificationRef;
    }

    if (!formData.summary?.trim()) {
      errors.summary = "Profile Brief is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = summaryRef;
    }

    if (!formData.gender?.trim()) {
      errors.gender = "Gender is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = genderRef;
    }

    if (!formData.emailID?.trim()) {
      errors.email = "Email is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = emailRef;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailID)) {
      errors.email = "Invalid email format";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = emailRef;
    }

    // UPDATED: Phone validation - must start with 6-9 and be exactly 10 digits
    if (!formData.phoneNo?.trim()) {
      errors.phone = "Phone number is required";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = phoneRef;
    } else if (!/^[6-9]\d{9}$/.test(formData.phoneNo)) {
      errors.phone = "Phone number must start with 6-9 and be exactly 10 digits";
      isValid = false;
      if (!firstErrorRef) firstErrorRef = phoneRef;
    }

    setValidationErrors(errors);

    const dynamicValidation = validateAllDynamicFields();

    if (!isValid || !dynamicValidation.isValid) {
      setShowValidationAlert(true);

      const issues: string[] = [];
      if (!isValid) issues.push("Fill all mandatory fields");
      if (!dynamicValidation.isValid) issues.push(...dynamicValidation.errors);

      setAlert(`⚠️ Please fix the following: ${issues.join(", ")}`);
      setTimeout(() => {
        setShowValidationAlert(false);
        setAlert("");
      }, 5000);

      if (firstErrorRef) {
        scrollToFirstError(firstErrorRef);
      }

      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateMandatoryFields()) return;

    if (!userId) {
      Toast.error("User session expired. Please login again.");
      return;
    }

    if (!uploadedImagePath) {
      Toast.error("Please upload doctor image first");
      return;
    }

    try {
      setLoading(true);
      setAlert("📤 Creating doctor profile...");

      const payload = {
        userId: parseInt(userId),
        userIp: userIp,
        EmpCode:formData.EmpCode,
        locationId: formData.locationId || 0,
        doctorName: formData.name,
        locationName: formData.locationName,
        designation: formData.designation,
        experienceYears: extractNumericValue(formData.experience),
        doctorFees: extractNumericValue(formData.fee),
        languages: formData.languages,
        qualification: formData.qualification,
        professionalSummary: formData.summary,
        awardsAchievements: formData.awards,
        researchPublications: formData.publications,
        previousExperiance: formData.previousExperiance,
        areaOfInterest: formData.areaOfInterest,
        status: "N",
        Source:"MKT",
        gender: formData.gender,
        emailID: formData.emailID,
        phoneNo: formData.phoneNo,
        registrationNo: formData.registrationNo,
        feedback: formData.feedback || "",
        remark: formData.remark || "",
        event: formData.event,
        namePrefixCode: formData.namePrefixCode,
        imagePath: uploadedImagePath,
        specializationId: formData.specializationId || 0,
        secondaryLocations: formData.secondaryLocations,
      };

      await createNewDoctor(payload);

      Toast.success("Doctor profile created successfully!");
      navigate("/dashboard")
      resetForm();
    } catch (error: any) {
      console.error("Error creating doctor profile:", error);
      Toast.error(
        `❌ ${error?.response?.data?.message || "Failed to create profile. Please try again."}`
      );
    } finally {
      setLoading(false);
      setAlert("");
    }
  };

  const resetForm = () => {
    if (doctorImagePreview) {
      URL.revokeObjectURL(doctorImagePreview);
    }

    setFormData({
      name: "",
      namePrefixCode: "",
      locationId: null,
      locationName: "",
      designation: "",
      designationId: null,
      experience: "",
      fee: "",
      languages: "",
      qualification: "",
      summary: "",
      specializationId: null,
      registrationNo: "",
      gender: "",
      emailID: "",
      phoneNo: "",
      status: "N",
      feedback: "",
      remark: "Create New Doctor Profile",
      event: "Add New Doctor Profile",
      areaOfInterest: [],
      previousExperiance: [],
      awards: [],
      publications: [],
      secondaryLocations: [],
      EmpCode:""
    });
    setDoctorImageFile(null);
    setDoctorImagePreview("");
    setUploadedImagePath("");
    setValidationErrors({});
    setDynamicFieldErrors({});
    setSelectedDepartmentId(null);
  };

  const SectionHeader: React.FC<{ title: string; required?: boolean }> = ({
    title,
    required = false,
  }) => (
    <div className="flex items-center gap-2 mt-3 first:mt-0">
      <p className="text-[11px] font-semibold text-gray-800 uppercase tracking-wide">
        {title}
        {required && <span className="text-red-500 ml-1">*</span>}
      </p>
    </div>
  );

  const DynamicRoleField: React.FC<{
    item: RoleDescription;
    index: number;
    section: "areaOfInterest" | "previousExperiance";
    borderColor: string;
    roleLabel: string;
  }> = ({ item, index, section, borderColor, roleLabel }) => {
    const isRoleEmpty = !item.role.trim();
    const isDescEmpty = !item.description.trim();
    const hasError = dynamicFieldErrors[section];

    return (
      <div
        className={`bg-white border-2 ${borderColor} p-4 rounded-lg shadow-sm relative hover:shadow-md transition-shadow`}
      >
        <button
          type="button"
          onClick={() => removeRoleRow(section, index)}
          className="absolute top-0.5 right-0.5 w-5 h-5 bg-red-500 text-white rounded-full hover:bg-red-600 flex items-center justify-center font-bold shadow-md transition-all hover:scale-110 text-xs"
        >
          ×
        </button>

        <div className="mb-3">
          <label className="block text-xs font-medium text-gray-700 mb-1">
            {roleLabel}
          </label>
          <input
            type="text"
            value={item.role}
            onChange={(e) => updateRoleArray(section, index, "role", e.target.value)}
            className={`w-full px-3 py-2 text-sm border-2 rounded-lg transition-all focus:outline-none focus:ring-1 ${
              isRoleEmpty && hasError
                ? "border-red-400 bg-red-50 focus:ring-red-400"
                : "border-gray-300 hover:border-gray-400 focus:ring-blue-500"
            }`}
            placeholder={`Enter ${roleLabel.toLowerCase()}`}
          />
          {isRoleEmpty && hasError && (
            <p className="text-[10px] text-red-600 mt-1 flex items-center gap-1">
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              Required field
            </p>
          )}
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            value={item.description}
            onChange={(e) =>
              updateRoleArray(section, index, "description", e.target.value)
            }
            className={`w-full px-3 py-2 text-sm border-2 rounded-lg transition-all focus:outline-none focus:ring-1 ${
              isDescEmpty && hasError
                ? "border-red-400 bg-red-50 focus:ring-red-400"
                : "border-gray-300 hover:border-gray-400 focus:ring-blue-500"
            }`}
            rows={3}
            placeholder="Enter description"
          />
          {isDescEmpty && hasError && (
            <p className="text-[10px] text-red-600 mt-1 flex items-center gap-1">
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              Required field
            </p>
          )}
        </div>
      </div>
    );
  };

  /* ================= UI ================= */

  return (
    <div className="bg-gradient-to-br from-white to-blue-50 rounded-xl shadow-lg border border-blue-200 overflow-hidden">
      <div className="bg-gradient-to-r from-[#184A84] to-[#2563EB] px-6 py-3 border-b-4 border-[#0F3A6F]">
        <h2 className="text-xl font-bold text-white flex items-center gap-2">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
            />
          </svg>
          Create New Doctor Profile
        </h2>
      </div>

      {alert && (
        <div
          className={`mx-6 mt-4 p-3 border-l-4 rounded-lg shadow-sm flex items-center gap-2 ${
            showValidationAlert
              ? "bg-gradient-to-r from-red-50 to-orange-50 border-red-500 text-red-800"
              : "bg-gradient-to-r from-green-50 to-emerald-50 border-green-500 text-green-800"
          }`}
        >
          <span className="font-medium text-xs">{alert}</span>
        </div>
      )}

      <div className="h-[calc(100vh-200px)] overflow-y-auto p-6 space-y-4">
        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2 space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div ref={titleRef}>
                <SectionHeader title="Title" required />
                <SearchableDropdown
                  value={formData.namePrefixCode}
                  placeholder="Select title"
                  options={titles}
                  onSelect={(v) => update("namePrefixCode", v.label)}
                />
                {validationErrors.namePrefixCode && (
                  <ValidationErrorMessage message={validationErrors.namePrefixCode} />
                )}
              </div>
              <div>
                <SectionHeader title="Doctor Name " required />
                <input
                  ref={nameRef}
                  type="text"
                  value={formData.name}
                  onChange={handleNameChange}
                  placeholder="Enter doctor name"
                  maxLength={50}
                  className="w-full px-3 py-1 text-xs border border-1 border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {validationErrors.name && (
                  <ValidationErrorMessage message={validationErrors.name} />
                )}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div ref={genderRef}>
                <SectionHeader title="Gender" required />
                <SearchableDropdown
                  value={
                    formData.gender === "M" 
                      ? "Male" 
                      : formData.gender === "F" 
                      ? "Female" 
                      : ""
                  }
                  placeholder="Select gender"
                  options={[
                    { id: 1, label: "Male" },
                    { id: 2, label: "Female" },
                  ]}
                  onSelect={(v) => {
                    const genderCode = v.label === "Male" ? "M" : "F";
                    update("gender", genderCode);
                  }}
                />
                {validationErrors.gender && (
                  <ValidationErrorMessage message={validationErrors.gender} />
                )}
              </div>
              <div>
                <SectionHeader title="Email ID" required />
                <input
                  ref={emailRef}
                  type="email"
                  value={formData.emailID}
                  onChange={handleEmailChange}
                  placeholder="doctor@example.com"
                  className="w-full px-3 py-1 text-xs border border-1 border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {validationErrors.email && (
                  <ValidationErrorMessage message={validationErrors.email} />
                )}
              </div>
            </div>

            

            <div className="grid grid-cols-2 gap-4">
              <div ref={locationRef}>
                <SectionHeader title="Primary Location" required />
                <SearchableDropdown
                  value={formData.locationName}
                  placeholder="Select primary location"
                  options={locations}
                  onSelect={handlePrimaryLocationChange}
                />
                {validationErrors.locationName && (
                  <ValidationErrorMessage message={validationErrors.locationName} />
                )}
              </div>

              <div ref={secondaryLocationsRef}>
                <SectionHeader title="Secondary Locations" />
                <LocationMultiSelect
                  locations={locations.filter(loc => loc.id !== formData.locationId)}
                  selectedLocationIds={formData.secondaryLocations.map(sl => sl.locationId.toString()).join(',')}
                  onChange={handleSecondaryLocationsChange}
                  disabled={!formData.locationId}
                />
                <p className="text-xs text-gray-500 mt-0.5">
                  {!formData.locationId ? "Select primary location first" : "Select additional locations"}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div ref={designationRef}>
                <SectionHeader title="Designation" required />
                <SearchableDropdown
                  value={formData.designation}
                  placeholder="Select designation"
                  options={designations}
                  onSelect={(v) => {
                    update("designation", v.label);
                    update("designationId", v.id);
                  }}
                />
                {validationErrors.designation && (
                  <ValidationErrorMessage message={validationErrors.designation} />
                )}
              </div>
              <div ref={departmentRef}>
                <SectionHeader title="Department" required />
                <SearchableDropdown
                  value={
                    selectedDepartmentId
                      ? departments.find((d) => d.DepartmentId === selectedDepartmentId)
                          ?.DepartmentName || ""
                      : ""
                  }
                  placeholder="Select department"
                  options={departments.map((dept) => ({
                    id: dept.DepartmentId,
                    label: dept.DepartmentName,
                  }))}
                  onSelect={handleDepartmentChange}
                />
                {validationErrors.department && (
                  <ValidationErrorMessage message={validationErrors.department} />
                )}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div ref={specializationRef}>
                <SectionHeader title="Specialization" required />
                <SearchableDropdown
                  value={
                    formData.specializationId
                      ? specializations.find(
                          (s) => s.SpecializationId === formData.specializationId
                        )?.SpecializationName || ""
                      : ""
                  }
                  placeholder={
                    selectedDepartmentId ? "Select specialization" : "Select department first"
                  }
                  options={specializations.map((spec) => ({
                    id: spec.SpecializationId,
                    label: spec.SpecializationName,
                  }))}
                  onSelect={handleSpecializationChange}
                />
                {validationErrors.specialization && (
                  <ValidationErrorMessage message={validationErrors.specialization} />
                )}
              </div>
              <div>
                <SectionHeader title="Experience " required />
                <input
                  ref={experienceRef}
                  type="text"
                  value={formData.experience}
                  onChange={handleExperienceChange}
                  placeholder="Enter years (max 99)"
                  maxLength={2}
                  className="w-full px-3 py-1 text-xs border border-1 border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {validationErrors.experience && (
                  <ValidationErrorMessage message={validationErrors.experience} />
                )}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <SectionHeader title="Consultation Fee " required />
                <input
                  ref={feeRef}
                  type="text"
                  value={formData.fee}
                  onChange={handleFeeChange}
                  placeholder="Enter fee (max 99999)"
                  maxLength={5}
                  className="w-full px-3 py-1 text-xs border border-1 border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {validationErrors.fee && (
                  <ValidationErrorMessage message={validationErrors.fee} />
                )}
              </div>
              <div ref={languagesRef}>
                <SectionHeader title="Languages" required />
                <LanguageMultiSelect
                  languages={availableLanguages}
                  selectedLanguages={formData.languages}
                  onChange={(v) => update("languages", v)}
                  disabled={false}
                />
                {validationErrors.languages && (
                  <ValidationErrorMessage message={validationErrors.languages} />
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              <div>
                <SectionHeader title="Employee Code" required/>
                <input
                  ref={employeCodeRef}
                  type="text"
                  value={formData.EmpCode}
                  onChange={handleEmployeeCodeChange}
                  placeholder="Enter registration number"
                  maxLength={30}
                  className="w-full px-3 py-1 text-xs border border-1 border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {validationErrors.EmpCode && (
                  <ValidationErrorMessage message={validationErrors.EmpCode}/>
                )}
              </div>
              <div>
                <SectionHeader title="Registration Number " />
                <input
                  ref={registrationNoRef}
                  type="text"
                  value={formData.registrationNo}
                  onChange={handleRegistrationNoChange}
                  placeholder="Enter registration number"
                  maxLength={30}
                  className="w-full px-3 py-1 text-xs border border-1 border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {validationErrors.registrationNo && (
                  <ValidationErrorMessage message={validationErrors.registrationNo}/>
                )}
              </div>
              <div>
                <SectionHeader title="Phone Number " required />
                <input
                  ref={phoneRef}
                  type="tel"
                  value={formData.phoneNo}
                  onChange={handlePhoneChange}
                  placeholder="Enter 10-digit phone"
                  maxLength={10}
                  className="w-full px-3 py-1 text-xs border border-1 border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {validationErrors.phone && (
                  <ValidationErrorMessage message={validationErrors.phone} />
                )}
              </div>
            </div>
          </div>

          {/* Right Section - Doctor Photo */}
          <div ref={doctorImageRef} className="col-span-1">
            <div className="border-2 border-[#00947D] rounded-lg p-4 bg-white h-full flex flex-col">
              <SectionHeader title="Doctor Photo" required />
              <div className="flex flex-col items-center justify-center flex-grow mt-3">
                <div className="sm:w-60 flex items-center justify-center bg-gray-100 rounded-sm border-2 border-dashed border-gray-300">
                  {doctorImagePreview ? (
                    <img
                      src={doctorImagePreview}
                      className="h-full w-full rounded-lg object-cover"
                      alt="Doctor"
                    />
                  ) : (
                    <img
                      src={Doctor}
                      className="h-full w-full rounded-lg object-cover"
                      alt="Doctor"
                    />
                  )}
                </div>
                <div className="flex flex-col gap-2 mt-4 w-full">
                  <label
                    htmlFor="photoUpload"
                    className={`cursor-pointer flex items-center justify-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 text-sm font-medium transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    {loading ? "Uploading..." : "Upload Photo"}
                  </label>
                  <input
                    type="file"
                    id="photoUpload"
                    hidden
                    accept="image/webp"
                    onChange={handlePhotoUpload}
                    disabled={loading}
                  />
                  {doctorImagePreview && (
                    <button
                      type="button"
                      onClick={handleDeletePhoto}
                      disabled={loading}
                      className="flex items-center justify-center gap-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 text-sm font-medium transition-colors disabled:opacity-50"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                      Delete
                    </button>
                  )}
                </div>
                {validationErrors.doctorImage && (
                  <div className="mt-2 w-full">
                    <ValidationErrorMessage message={validationErrors.doctorImage} />
                  </div>
                )}
                <p className="text-xs text-gray-500 mt-3 text-center">
                  Max size: 5MB<br /> Format: WEBP only
                </p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <SectionHeader title="Qualification" required />
          <textarea
            ref={qualificationRef}
            value={formData.qualification}
            onChange={(e) => update("qualification", e.target.value)}
            placeholder="Enter qualifications (e.g., MBBS, MD, DNB)"
            rows={3}
            className="w-full px-3 py-2 text-sm border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          {validationErrors.qualification && (
            <ValidationErrorMessage message={validationErrors.qualification} />
          )}
        </div>

        <div>
          <SectionHeader title="Profile Brief" required />
          <textarea
            ref={summaryRef}
            value={formData.summary}
            onChange={(e) => update("summary", e.target.value)}
            placeholder="Add a professional summary..."
            rows={4}
            className="w-full px-3 py-2 text-sm border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          {validationErrors.summary && (
            <ValidationErrorMessage message={validationErrors.summary} />
          )}
        </div>

        <div>
          <SectionHeader title="Area of Interest" />
          <div className="space-y-3 mt-2">
            {formData.areaOfInterest.map((item, idx) => (
              <DynamicRoleField
                key={idx}
                item={item}
                index={idx}
                section="areaOfInterest"
                borderColor="border-blue-200"
                roleLabel="Role/Specialty"
              />
            ))}
          </div>

          {dynamicFieldErrors.areaOfInterest && (
            <ErrorBanner message={dynamicFieldErrors.areaOfInterest} />
          )}

          <button
            type="button"
            className="flex items-center gap-2 px-4 py-2 mt-3 border border-green-400 text-green-700 rounded-lg hover:bg-green-50 font-semibold text-sm shadow-sm hover:shadow transition-all"
            onClick={() => addRoleRow("areaOfInterest")}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            Add Area of Interest
          </button>
        </div>

        <div>
          <SectionHeader title="Previous Experience" />
          <div className="space-y-3 mt-2">
            {formData.previousExperiance.map((item, idx) => (
              <DynamicRoleField
                key={idx}
                item={item}
                index={idx}
                section="previousExperiance"
                borderColor="border-green-200"
                roleLabel="Role / Hospital"
              />
            ))}
          </div>

          {dynamicFieldErrors.previousExperiance && (
            <ErrorBanner message={dynamicFieldErrors.previousExperiance} />
          )}

          <button
            type="button"
            className="flex items-center gap-2 px-4 py-2 mt-3 border border-green-400 text-green-700 rounded-lg hover:bg-green-50 font-semibold text-sm shadow-sm hover:shadow transition-all"
            onClick={() => addRoleRow("previousExperiance")}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            Add Experience
          </button>
        </div>

        <div className="border border-gray-300 p-4 bg-white rounded-lg">
          <SectionHeader title="Awards & Achievements" />
          <DynamicArray
            label="Awards & Achievements"
            items={formData.awards}
            onChange={(v) => update("awards", v)}
          />
        </div>

        <div className="border border-gray-300 p-4 bg-white rounded-lg">
          <SectionHeader title="Research & Publications" />
          <DynamicArray
            label="Research & Publications"
            items={formData.publications}
            onChange={(v) => update("publications", v)}
          />
        </div>
      </div>

      <div className="sticky bottom-0 bg-gradient-to-r from-gray-50 to-blue-50 px-6 py-4 border-t-2 border-blue-200 flex gap-3 shadow-lg">
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          <svg className="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
          </svg>
          {loading ? "Creating..." : "Create Profile"}
        </Button>

        <Button variant="danger" onClick={resetForm} disabled={loading}>
          <svg
            className="w-4 h-4 inline mr-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          Reset
        </Button>
      </div>
    </div>
  );
};

export default CreateDoctorProfile;
